import resume from '../assets/pdf/resume.pdf';
import profilephoto from '../assets/png/profile-pic.jpeg';

export const headerData = {
  name: 'Hiren Dhadhal',
  title: 'Computer Science & Engineering Graduate',
  desciption:
    "B.Tech graduate under Computer science department at NIT Surat. I'm self-motivated and hardworking graduate seeking an opportunity to work in a challenging environment to prove my coding skills and utilize my knowledge of various databases for the growth of us. ",
  image: profilephoto,
  resumePdf: resume,
};
